module.exports = __webpack_public_path__ + "img/change-of-direction.af8b9415.png";